/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
/**
 * Defines values for EnableState.
 * Possible values include: 'Enabled', 'Disabled'
 * @readonly
 * @enum {string}
 */
export var EnableState;
(function (EnableState) {
  EnableState["Enabled"] = "Enabled";
  EnableState["Disabled"] = "Disabled";
})(EnableState || (EnableState = {}));
/**
 * Defines values for OsType.
 * Possible values include: 'Windows', 'Linux'
 * @readonly
 * @enum {string}
 */
export var OsType;
(function (OsType) {
  OsType["Windows"] = "Windows";
  OsType["Linux"] = "Linux";
})(OsType || (OsType = {}));
/**
 * Defines values for Availability.
 * Possible values include: 'Available', 'Unavailable', 'Deprecated', 'Disabled'
 * @readonly
 * @enum {string}
 */
export var Availability;
(function (Availability) {
  /**
   * The item is available
   */
  Availability["Available"] = "Available";
  /**
   * The item is currently unavailable.
   */
  Availability["Unavailable"] = "Unavailable";
  /**
   * The item is deprecated and will eventually be disabled.
   */
  Availability["Deprecated"] = "Deprecated";
  /**
   * The item has been permanently disabled.
   */
  Availability["Disabled"] = "Disabled";
})(Availability || (Availability = {}));
/**
 * Defines values for VirtualMachineState.
 * Possible values include: 'Creating', 'Updating', 'Deleting', 'Moving', 'Stopped', 'Starting',
 * 'Running', 'Stopping', 'ResettingPassword', 'Reimaging', 'Redeploying'
 * @readonly
 * @enum {string}
 */
export var VirtualMachineState;
(function (VirtualMachineState) {
  /**
   * The VM is being created.
   */
  VirtualMachineState["Creating"] = "Creating";
  /**
   * The VM is being updated.
   */
  VirtualMachineState["Updating"] = "Updating";
  /**
   * The VM is being deleted.
   */
  VirtualMachineState["Deleting"] = "Deleting";
  /**
   * The VM is being moved.
   */
  VirtualMachineState["Moving"] = "Moving";
  /**
   * The VM is currently stopped.
   */
  VirtualMachineState["Stopped"] = "Stopped";
  /**
   * The VM is starting.
   */
  VirtualMachineState["Starting"] = "Starting";
  /**
   * The VM is running.
   */
  VirtualMachineState["Running"] = "Running";
  /**
   * The VM is stopping.
   */
  VirtualMachineState["Stopping"] = "Stopping";
  /**
   * The VM password is being reset.
   */
  VirtualMachineState["ResettingPassword"] = "ResettingPassword";
  /**
   * The VM is reimaging.
   */
  VirtualMachineState["Reimaging"] = "Reimaging";
  /**
   * The VM is redeploying.
   */
  VirtualMachineState["Redeploying"] = "Redeploying";
})(VirtualMachineState || (VirtualMachineState = {}));
/**
 * Defines values for PriceUnit.
 * Possible values include: 'WindowsHourly', 'LinuxHourly', 'HybridBenefitHourly', 'InactiveHourly'
 * @readonly
 * @enum {string}
 */
export var PriceUnit;
(function (PriceUnit) {
  /**
   * Hourly cost for Windows VMs.
   */
  PriceUnit["WindowsHourly"] = "WindowsHourly";
  /**
   * Hourly cost for Linux VMs.
   */
  PriceUnit["LinuxHourly"] = "LinuxHourly";
  /**
   * Hourly cost for VMs with Azure Hybrid Benefit.
   */
  PriceUnit["HybridBenefitHourly"] = "HybridBenefitHourly";
  /**
   * Hourly cost for inactive VMs regardless of OS.
   */
  PriceUnit["InactiveHourly"] = "InactiveHourly";
})(PriceUnit || (PriceUnit = {}));
/**
 * Defines values for OperationStatus.
 * Possible values include: 'NotStarted', 'InProgress', 'Succeeded', 'Failed', 'Canceled'
 * @readonly
 * @enum {string}
 */
export var OperationStatus;
(function (OperationStatus) {
  /**
   * The operation has been accepted but hasn't started.
   */
  OperationStatus["NotStarted"] = "NotStarted";
  /**
   * The operation is running
   */
  OperationStatus["InProgress"] = "InProgress";
  /**
   * The operation Succeeded
   */
  OperationStatus["Succeeded"] = "Succeeded";
  /**
   * The operation failed
   */
  OperationStatus["Failed"] = "Failed";
  /**
   * Not supported yet
   */
  OperationStatus["Canceled"] = "Canceled";
})(OperationStatus || (OperationStatus = {}));
/**
 * Defines values for ProvisioningState.
 * Possible values include: 'Creating', 'Updating', 'Deleting', 'Succeeded', 'Failed', 'Locked'
 * @readonly
 * @enum {string}
 */
export var ProvisioningState;
(function (ProvisioningState) {
  /**
   * Resource is in the process of being created.
   */
  ProvisioningState["Creating"] = "Creating";
  /**
   * New property values are being applied to the resource.
   */
  ProvisioningState["Updating"] = "Updating";
  /**
   * Resource is in the process of being deleted.
   */
  ProvisioningState["Deleting"] = "Deleting";
  /**
   * Resource is in healthy state after creation or update operation.
   */
  ProvisioningState["Succeeded"] = "Succeeded";
  /**
   * Previous operation on the resource has failed leaving resource in unhealthy state.
   */
  ProvisioningState["Failed"] = "Failed";
  /**
   * The resource is locked and changes are currently blocked. This could be due to maintenance or
   * a scheduled operation. The state will go back to succeeded once the locking operation has
   * finished.
   */
  ProvisioningState["Locked"] = "Locked";
})(ProvisioningState || (ProvisioningState = {}));
/**
 * Defines values for ConnectionType.
 * Possible values include: 'Public', 'Private', 'None'
 * @readonly
 * @enum {string}
 */
export var ConnectionType;
(function (ConnectionType) {
  ConnectionType["Public"] = "Public";
  ConnectionType["Private"] = "Private";
  ConnectionType["None"] = "None";
})(ConnectionType || (ConnectionType = {}));
/**
 * Defines values for ShutdownOnIdleMode.
 * Possible values include: 'None', 'UserAbsence', 'LowUsage'
 * @readonly
 * @enum {string}
 */
export var ShutdownOnIdleMode;
(function (ShutdownOnIdleMode) {
  /**
   * The VM won't be shut down when it is idle.
   */
  ShutdownOnIdleMode["None"] = "None";
  /**
   * The VM will be considered as idle when there is no keyboard or mouse input.
   */
  ShutdownOnIdleMode["UserAbsence"] = "UserAbsence";
  /**
   * The VM will be considered as idle when user is absent and the resource (CPU and disk)
   * consumption is low.
   */
  ShutdownOnIdleMode["LowUsage"] = "LowUsage";
})(ShutdownOnIdleMode || (ShutdownOnIdleMode = {}));
/**
 * Defines values for CreatedByType.
 * Possible values include: 'User', 'Application', 'ManagedIdentity', 'Key'
 * @readonly
 * @enum {string}
 */
export var CreatedByType;
(function (CreatedByType) {
  CreatedByType["User"] = "User";
  CreatedByType["Application"] = "Application";
  CreatedByType["ManagedIdentity"] = "ManagedIdentity";
  CreatedByType["Key"] = "Key";
})(CreatedByType || (CreatedByType = {}));
/**
 * Defines values for LabState.
 * Possible values include: 'Draft', 'Publishing', 'Scaling', 'Syncing', 'Published'
 * @readonly
 * @enum {string}
 */
export var LabState;
(function (LabState) {
  /**
   * The lab is currently in draft (has not been published).
   */
  LabState["Draft"] = "Draft";
  /**
   * The lab is publishing.
   */
  LabState["Publishing"] = "Publishing";
  /**
   * The lab is scaling.
   */
  LabState["Scaling"] = "Scaling";
  /**
   * The lab is syncing users.
   */
  LabState["Syncing"] = "Syncing";
  /**
   * The lab has been published.
   */
  LabState["Published"] = "Published";
})(LabState || (LabState = {}));
/**
 * Defines values for CreateOption.
 * Possible values include: 'Image', 'TemplateVM'
 * @readonly
 * @enum {string}
 */
export var CreateOption;
(function (CreateOption) {
  /**
   * An image is used to create all lab user virtual machines. When this option is set, no template
   * VM will be created.
   */
  CreateOption["Image"] = "Image";
  /**
   * A template VM will be used to create all lab user virtual machines.
   */
  CreateOption["TemplateVM"] = "TemplateVM";
})(CreateOption || (CreateOption = {}));
/**
 * Defines values for SkuTier.
 * Possible values include: 'Free', 'Basic', 'Standard', 'Premium'
 * @readonly
 * @enum {string}
 */
export var SkuTier;
(function (SkuTier) {
  SkuTier["Free"] = "Free";
  SkuTier["Basic"] = "Basic";
  SkuTier["Standard"] = "Standard";
  SkuTier["Premium"] = "Premium";
})(SkuTier || (SkuTier = {}));